const zh = {
  lang: {
    zh: '中文',
    en: 'English'
  },
  menu: {
    home: '首页',
    products: '产品中心',
    solutions: '解决方案',
    news: '公司动态',
    about: '关于我们',
    list: {
      aiPlatform: 'AI融合管理平台',
      aiDeviceExpert: 'AI设备专家平台',
      aiDigitalHuman: 'AI数字人平台',
      aiEdgeDevice: 'AI边缘算力终端',
      specialRobot: '特种机器人',
      coalClaw: 'CoalClaw助手',
      coalMineVideo: '煤矿视频反三违',
      mineAi: '矿山全景AI监管',
      chemicalAi: '化工AI视频监管',
      energyMaintenance: '能源行业智能运维',
      powerGridInspection: '电网智能巡检',
      aiQuality: 'AI质检及安全生产'
    }
  },
  common: {
    siteTitle: '上海软沃智能科技有限公司',
    contactUs: '联系我们',
    viewDetails: '查看详情',
    loading: '加载中...',
    noNews: '暂无动态',
    companyMission: '公司使命',
    companyVision: '公司愿景',
    companyValues: '价值观',
    companyIntro: '公司介绍',
    teamHistory: '团队历程',
    certSystem: '认证体系',
    ipRights: '知识产权',
    serviceExp: '服务经验',
    mineAlgorithm: '智能矿山算法',
    citiesCovered: '覆盖城市',
    customerCases: '客户案例',
    effect: '效果',
    evaluation: '评价'
  },
  footer: {
    contact: '联系我们',
    companyName: '上海软沃智能科技有限公司',
    address: '上海市普陀区中山北路2143号9层',
    icp: '沪ICP备2026037328号-1'
  },
  sectionTitle: {
    coreProducts: '核心产品',
    coreProductsSub: '聚焦工业智能化场景，打造集行业大模型、AI视觉识别、智能装备与边缘计算于一体的全栈产品体系',
    solutions: '解决方案',
    solutionsSub: '面向矿山、能源、化工、电网、烟草及智能制造等行业，提供涵盖AI视觉、大模型应用、智能装备与数字化平台的一站式智能化解决方案。',
    coreAbility: '核心能力',
    coreAbilitySub: '10年+深耕煤炭、化工行业，100+煤矿落地案例支撑',
    industryModel: '行业模型',
    customerCase: '客户案例',
    productFeatures: '产品功能',
    solutionFeatures: '方案功能',
    solutionArchitecture: '方案架构',
    solutionAdvantages: '方案优势'
  },
  home: {
    banner: {
      aiEngine: {
        title: 'AI技术引擎',
        desc: '融合AI视觉、能源行业大模型、语音语义识别及智能数据中台构建能源领域AI引擎',
        tags: ['智能体agent', '数字人', '智能装备制造机器人']
      },
      energySolution: {
        title: '能源行业AI解决方案服务商',
        desc: '算法、硬件、大模型三位一体，助力能源行业数智化转型',
        tags: ['AI', '数智化', '能源大脑']
      },
      digitalHuman: {
        title: 'AI数字人平台',
        desc: '煤矿行业的数字智能库，让每一位员工都能随时通过对话调取专业规程与作业标准',
        tags: ['智能问答', '标准库', '作业指导']
      },
      edgeDevice: {
        title: 'AI边缘算力终端',
        desc: '专为煤矿极恶劣环境设计的边缘算力载体，在井下一线提供毫秒级的AI分析',
        tags: ['防爆设计', '边缘计算', '实时分析']
      },
      drone: {
        title: '无人机巷道巡检',
        desc: '实时采集影像与点云，智能识别裂缝、变形、渗漏等隐患，提升效率、降低风险。',
        tags: ['自动巡检', '隐患识别', '三维建模']
      }
    },
    products: {
      fusion: {
        title: 'AI融合管理平台',
        desc: 'AI融合管理平台，数据驱动模型赋能行业场景解决安全问题。'
      },
      deviceExpert: {
        title: 'AI设备专家平台',
        desc: 'AI设备专家平台，设备全生命周期监控，预测性维护，故障快速诊断'
      },
      digitalHuman: {
        title: 'AI数字人平台',
        desc: '煤矿行业的数字智库，让每一位员工都能随时通过对话调取专业规程与作业标准'
      },
      edgeDevice: {
        title: 'AI边缘算力终端',
        desc: 'AI边缘算力终端，高可靠安全边缘算力设备，搭载煤矿行业专有模型，实时分析，属地闭环控制。'
      },
      specialRobot: {
        title: '特种机器人',
        desc: '液压支架辅助机械臂，人机协同辅助完成对孔和销轴插入工作，提升组装效率，降低作业风险。'
      },
      coalClaw: {
        title: 'CoalClaw助手',
        desc: 'CoalClaw煤矿私有化小龙虾，管理者的经营助手，快速掌握经营生产数据。'
      }
    },
    solutions: {
      antiViolation: {
        title: '煤矿视频反三违',
        desc: '通过视觉智能闭环管理，显著降低人为操作风险，实现作业标准化'
      },
      mineMonitor: {
        title: '矿山全景AI监管',
        desc: '覆盖综采面、皮带运输、泵房、提升机房等全流程智能化监测'
      },
      chemicalMonitor: {
        title: '化工AI视频监管',
        desc: '危险区穿戴检测、明火烟雾侦、危险品装卸规范化监管测'
      }
    },
    abilities: {
      llm: {
        title: '煤矿行业大模型',
        desc: '深度学习煤矿各类生产、安全知识，能够理解各类复杂业务逻辑、自动分析各类风险、辅助决策支撑'
      },
      vision: {
        title: '全场景AI视频识别',
        desc: '百万级煤矿行业数据集，100+行业场景算法，算法准确率行业领先，毫秒级响应速度'
      },
      hardware: {
        title: '软硬一体化交付',
        desc: '算法深度适配自研硬件，从一体机到专用传感器，实现边缘计算与现场报警的无缝协同'
      },
      lifecycle: {
        title: '全生命周期服务',
        desc: '提供从现场调研、方案设计、安装调试到后期运维的一站式闭环服务，真正解决落地难题'
      }
    },
    industry: {
      mainTransport: '主运输',
      auxTransport: '辅助运输',
      mining: '采煤',
      tunneling: '掘进',
      ventilation: '通风',
      others: '其他',
      models: {
        mainTransport: {
          dynamicBelt: '动态皮带区域识别',
          coalBunker: '煤仓上口堆煤识别',
          beltRider: '皮带乘人越位监测',
          largeCoal: '皮带大块煤识别',
          foreignObject: '皮带异物识别',
          coalVolume: '皮带煤量监测',
          beltDeviation: '皮带跑偏识别',
          boltDetection: '皮带锚杆识别'
        },
        auxTransport: {
          monkeyCar: '乘坐猴车携带超长物料',
          manCarGate: '人车静态落闸识别',
          leanManCar: '倚靠人车识别',
          overLoad: '料车超挂告警',
          winchRoom: '绞车硐室检修规范操作识别',
          tunnelCount: '绞车道人数统计',
          rubberCarHead: '胶轮车不能把头伸出车外',
          noRider: '行车不行人',
          mineCarRide: '趴蹬矿车识别',
          antiRunaway: '防跑车装置状态识别'
        },
        mining: {
          scraperAlign: '刮板机辅助找直检测',
          chainBreak: '刮板运输机断链监测',
          dangerZone: '动态危险区域闯入识别',
          rollerGuard: '滚筒与护帮板状态监测'
        },
        tunneling: {
          safetyRope: '掘进机上作业系安全绳识别',
          temporarySupport: '机载临时支护使用检测',
          gasProbe: '甲烷瓦斯探头检测',
          safetyNet: '防护网开关识别'
        },
        ventilation: {
          tunnelPerson: '风道人员记录',
          tunnelDeform: '风道巷道形变监测',
          damperSwitch: '风门开关状态识别'
        },
        others: {
          onDuty: '人员在岗识别',
          sleepDuty: '人员睡岗识别',
          crowd: '人员聚集监测',
          faceRecog: '人脸识别',
          keyRoom: '关键硐室人员经过记录',
          dangerZone: '危险区域人员闯入',
          cameraCover: '摄像头遮挡检测',
          noHelmet: '未佩戴安全帽识别',
          waterLevel: '水位预警识别',
          highTemp: '设备高温预警'
        }
      }
    },
    cases: {
      mineAiEye: {
        title: '矿场AI"慧眼"',
        desc: 'AI视频融合平台作为该矿生产指挥的"智慧大脑"，从绞车道、皮带道、风道三条核心通道入手，逐步覆盖全矿各系统。AI视频融合平台内置的30多个智能算法，成了管理人员最得力的帮手。带式输送机运行时，算法能自动识别大块煤矸、皮带跑偏、堆煤等异常；绞车道上，料车超挂、人员违规乘坐、跑车防护装置故障都逃不过AI"慧眼"；就连风门状态、固定场所人员经过这些细节，平台也能实时监测。"以前安监科忙得脚不沾地，现在一两个人就能轻松应对，既省时又省力，工作效率直接提升几倍。'
      },
      intelligentDispatch: {
        title: '某大型生产矿井"一张图"智能化调度中心建设',
        desc: '该矿井原本面临各系统数据孤岛、人工巡检效率低的痛点。通过部署AI融合管理平台，集成了井下300余个视频点位，利用AI引擎实现了人员违章抓拍、皮带异物检测、设备运行状态的统一实时监测。平台上线后，通过"驾驶舱"模式实现了全矿井一张图管理，安全隐患自动发现率提升至98%以上，安监人员从海量监控中解脱，实现了由"被动查看"向"主动预警"的监管转型。'
      },
      predictiveMaintenance: {
        title: '主运输系统核心驱动部预测性维护应用',
        desc: '在某选煤厂的长距离皮带运输系统中，通过在电机、减速机关键部位安装无线温振传感器，并接入AI设备专家平台。系统利用深度学习模型对历史运行数据进行建模，成功在一次例行生产中提前72小时预警了减速机轴承的疲劳损伤。相比传统定期停机检修，该方案减少了非计划停机时间40小时以上，节约设备维修成本及间接生产损失逾百万元。'
      },
      safetyAssistant: {
        title: '基层采掘工区安全规程智能助手应用',
        desc: '针对基层作业人员查阅安全技术措施不便、新规程学习周期长的问题。矿企在调度室和班前会区域部署了"问煤"智能体终端。采掘工人通过自然语言对话即可快速获取"综采面顶板管理"或"探放水作业标准"等专业知识。案例显示，该矿员工对安全操作规程的调取频率提升了5倍，技术员编制施工作业措施书的时间缩短了70%，显著夯实了生产现场的安全合规基础。'
      },
      edgeResponse: {
        title: '综采工作面边缘侧"反三违"毫秒级响应实践',
        desc: '在高瓦斯矿井的综采工作面，通过部署本安型井下智能防爆终端，将AI算法下沉至生产一线。终端在本地实时分析割煤机运行轨迹及人员安全距离，一旦发现人员违规进入片帮区域，无需上传云端，终端直接在现场联动声光报警器进行语音劝阻。该方案解决了井下带宽不足导致的延迟问题，使预警响应速度控制在200ms以内，将现场违章隐患消除在萌芽状态。'
      },
      unmannedInstallation: {
        title: '复杂地质条件下采煤工作面设备安装无人化探索',
        desc: '在某薄煤层工作面安装期间，由于空间狭小，人工调校支架姿态风险大、精度低。引入液压支架辅助安装机器人后，通过其搭载的高精度视觉感知系统自动识别支架中心线，辅助机械臂精准完成找正、对位与调校。案例结果显示，每班组安装效率提升了25%，且关键高风险区域实现了零人员进入，大幅降低了挤伤、碰伤等事故风险。'
      },
      officeAutomation: {
        title: '智慧矿山办公自动化与生产报表智能生成系统',
        desc: '某矿业集团利用Coalclaw私有化智能助手处理海量的生产日志与调度记录。助手通过本地大模型，自动提取每日各采区的割煤刀数、进尺、隐患排查数量等关键指标，并一键生成标准化的生产日报与安全分析周报。在实际应用中，矿办工作人员从机械的数据录入工作中释放，每日报表处理时间从3小时缩短至10分钟，且数据统计准确率达到了100%，极大地提升了管理效能。'
      },
      antiViolationUpgrade: {
        title: '某千万吨级矿井反三违智能升级',
        desc: '该矿井原依赖人工视频巡检，对皮带转弯处违规跨越、单人违章作业等隐患识别滞后',
        effect: '部署方案后，系统实现了对采掘工作面、皮带运输线的全时段监控。AI助手每日自动筛查违章行为，并将截取的小视频推送到管理人员手机APP。',
        evaluation: '运行三个月内，现场违章频率降低了75%，安监人员从"海量搜寻"转变为"精准核查"，显著提升了矿井的本质安全水平。'
      },
      fullScene: {
        title: '智慧矿山全场景感知体系构建',
        desc: '针对矿井流程冗长、监控点位分散、信息孤岛严重的现状，旨在构建一套全域智能监控网。',
        effect: '方案覆盖了从入井口到综采面的全路径。在主运环节，AI成功多次预警大块矸石堆积，避免了皮带撕裂事故；在提升机房，AI巡检代替了传统人工排班。',
        evaluation: '实现全矿关键岗位减人30%以上，生产异常响应时间由原来的10分钟缩短至30秒以内。'
      },
      chemicalPark: {
        title: '某化工园区数字化安监平台建设',
        desc: '园区内化工装置密集，涉及易燃易爆品存储，传统人工巡逻难以覆盖复杂的设备盲区。',
        effect: '方案上线后，对装卸区进行了算法全覆盖，多次精准识别到人员在装卸期间未挂地线及抽烟等严重违章行为。',
        evaluation: '该方案帮助园区构建了"自动发现、实时报警、联动处置"的防御机制，将安全隐患的发现准确率提升至98%以上，极大地降低了安全风险红线压力。'
      }
    }
  },
  about: {
    banner: {
      title: '关于我们',
      desc: '只做有价值的软件'
    },
    mission: '以数字科技为用户提供真实价值',
    vision: '致力于成为最懂行的智能化解决方案提供商',
    values: '以客户为中心实现自我价值',
    intro: '上海软沃智能科技有限公司成立于2010年，是一家以"人工智能·大数据"为主轴，"智能物联"和"网络安全"为两翼的高科技企业。能够为客户提供视觉融媒体平台、大数据平台、工业自动化、网络及数据安全等专业解决方案，致力成为最值得信赖的工业互联网数字化·智能化解决方案提供商。总部位于上海市，业务覆盖全国，目前已在多个省份设立分支机构，为政府、石油、矿山、化工、电网、烟草、汽车等细分行业客户提供专业的信息化建设产品、服务及解决方案。',
    stat1: '15年',
    stat2: '100+',
    stat3: '20+',
    stat4: '100+'
  },
  news: {
    banner: {
      title: '公司动态',
      desc: '聚焦行业前沿·记录企业成长·分享技术成果'
    },
    list: {
      item1: {
        title: '我司AI设备专家平台正式上线，助力智能制造全面升级',
        desc: '平台通过智能体Agent、数字人技术实现设备预测性维护，可帮助企业提升维修效率30%-50%，覆盖智能装备制造全场景。'
      },
      item2: {
        title: '受邀出席智能制造峰会，分享智能运维解决方案',
        desc: '公司技术团队在峰会发表主题演讲，围绕设备管理、故障分析、智能诊断等核心能力展开分享，获得行业高度认可。'
      },
      item3: {
        title: '新增多项软件著作权，技术实力再获权威认证',
        desc: '公司在设备智能监控、自动数据报表、AI故障诊断领域取得多项技术突破，成功获得国家版权局认证。'
      },
      item4: {
        title: '与多家制造企业达成合作，系统正式落地应用',
        desc: '公司设备管理平台成功落地多家制造企业，实现设备智能化管理、实时监控、自动预警等功能。'
      }
    }
  },
  products: {
    cp001: {
      name: 'AI融合管理平台',
      banner: {
        title: 'AI融合管理平台',
        desc: '工业安全守护者，实现一张图监控与智能告警'
      },
      features: {
        antiViolation: { title: 'AI反三违', desc: '' },
        mainTransport: { title: 'AI智能主/辅运输', desc: 'AI采掘工作面监控' },
        scraper: { title: 'AI刮板机异常检测', desc: '' }
      }
    },
    cp002: {
      name: 'AI设备专家平台',
      banner: {
        title: 'AI设备专家平台',
        desc: 'AI设备专家平台，设备全生命周期监控，预测性维护，故障快速诊断'
      },
      features: {
        management: { title: '设备管理', desc: '实现设备管理驾驶舱智能化' },
        analysis: { title: '故障分析', desc: '将专家经验固化到流程中' },
        report: { title: '数据报表', desc: '自动生成设备日报、应急报告等' }
      }
    },
    cp003: {
      name: 'AI数字人平台',
      banner: {
        title: 'AI数字人平台',
        desc: '煤矿行业的数字智库，让每一位员工都能随时通过对话调取专业规程与作业标准。'
      },
      features: {
        regulation: { title: '行业法规秒级检索', desc: '深度学习《煤矿安全规程》及各类操作规范，支持自然语言精准问答' },
        standard: { title: '标准化作业指导', desc: '随时随地推送对应的安全措施和标准化流程建议' },
        multiSource: { title: '多源支持', desc: '文字语言（含各类方言）均可以快速响应' }
      }
    },
    cp004: {
      name: 'AI边缘算力终端',
      banner: {
        title: 'AI边缘算力终端',
        desc: 'AI边缘算力终端，高可靠安全边缘算力设备，搭载煤矿行业专有模型，实时分析，属地闭环控制。'
      },
      features: {
        localCompute: { title: '本地化算力赋能', desc: '本安型防爆设计，支持在断网或低宽带环境下独立运行复杂算法' },
        alarm: { title: '实时声光报警', desc: '与算法联动，在发现违章的第一时间触发井下现场语音提醒' }
      }
    },
    cp005: {
      name: '特种机器人',
      banner: {
        title: '特种机器人',
        desc: '面向煤矿复杂、高危作业场景，融合机器人技术、智能感知与自主控制能力，实现危险作业替人、重复作业减人、智能巡检无人化，全面提升矿山安全生产与智能化运营水平。'
      },
      features: {
        robotReplace: { title: '危险作业机器人替代', desc: '针对液压支架安装、设备搬运、危险区域作业等高风险场景，通过机器人代替人工完成重体力、高危险性操作，有效降低人员安全风险，提高作业效率和施工质量。' },
        autoInspect: { title: '智能巡检自主运行', desc: '支持井下巷道、硐室机房、变电所、运输系统等场景自主巡检，实现设备状态监测、仪表识别、环境感知及异常发现，提升巡检覆盖率和实时性' },
        aiPerceive: { title: 'AI感知与协同联动', desc: '集成视觉识别、环境感知、定位导航和无线通信技术，可与调度平台、AI视频系统、设备管理系统协同联动，实现异常告警、远程操控和智能决策辅助，打造矿山智能运维新模式。' }
      }
    },
    cp006: {
      name: 'CoalClaw助手',
      banner: {
        title: 'CoalClaw助手',
        desc: 'CoalClaw煤矿私有化小龙虾，管理者的经营助手，快速掌握经营生产数据。'
      },
      features: {
        docReport: { title: '公文与报表自动化', desc: '自动整理生产日报、安全周报，并支持根据历史数据生成趋势图表' },
        taskManage: { title: '智能任务督办', desc: '自动提取会议纪要中的待办事项，并通过系统提醒相关责任人闭环处理' }
      }
    }
  },
  algorithm: {
    fa001: {
      name: '煤矿反三违解决方案',
      banner: {
        title: '煤矿反三违解决方案',
        desc: '集"智能视觉抓拍、安全知识助手、闭环管理流程"于一体，打造矿企开箱即用的AI安监专家'
      },
      features: {
        outOfBox: { title: '开箱即用算法库', desc: '预置人员聚集、违规跨越、脱岗检测、未佩戴自救器100+种针对煤矿规程开发的成熟算法，上线即实战' },
        knowledgeLink: { title: '知识库联动预警', desc: '深度集成"问煤"知识库，在触发违章抓拍的同时，自动关联展示对应的《安全规程》条款，辅助现场纠偏' },
        evidenceTrace: { title: '视频全证据链溯源', desc: '自动裁剪违章后的视频片段，建立"抓拍-推送-审核-整改消账"的标准化闭环管理流程' },
        quickDeploy: { title: '软硬件一体快速部署', desc: '适配防爆边缘终端，支持井下本地化实时处理，保障在极端环境下报警延迟低于200ms' }
      },
      advantages: {
        authority: { title: '权威合规赋能', desc: '算法逻辑深度对标《煤矿安全规程》，确保每一次违章抓拍都有据可依、符合监管要求' },
        knowledgeAssist: { title: '知识辅助纠偏', desc: '业内首创将AI视觉与"问煤"知识库联动，不仅发现违章，更能实时告知员工正确的作业标准' },
        zeroLeak: { title: '"零漏检"安监网络', desc: '利用高精度视觉模型克服井下低照度干扰，实现对关键工作、危险区域的全时段、无盲区监控' }
      }
    },
    fa002: {
      name: '矿山全场景AI视频识别解决方案',
      banner: {
        title: '矿山全场景AI视频识别解决方案',
        desc: '覆盖综采、主运、辅运、供电、提升等全流程，实现矿山从地面到井下的全维度数字化感知'
      },
      features: {
        faceMonitor: { title: '综采面智能监控', desc: '实时监测割煤机位置、刮板机断链、支架姿态及采区人员动态，确保采煤工艺规范执行' },
        transportProtect: { title: '主运输系统防护', desc: '针对皮带运输全线提供异物（锚杆/大块矸石）识别、皮带跑偏、撕裂及堆煤自动监测，联动急停报警。' },
        unmannedRoom: { title: '固定硐室无人值守', desc: '针对泵房、提升机房、变电所实现环境异常监测、巡检路径记录及异常温升警示，助力实现少人/无人值守' },
        multiTerminal: { title: '全场景多端联动', desc: '视频流通过智能数据中台处理，可同时在调度室大屏、PC端及移动端实时呈现全矿动态。' }
      },
      advantages: {
        fullCoverage: { title: '矿山全场景覆盖', desc: '覆盖矿山综采、主运、辅运、供电、提升等全业务场景，实现井上井下全域视频智能感知' },
        aiWarning: { title: 'AI识别主动预警', desc: '基于AI视觉识别技术，实现多类型违章行为与风险隐患的实时预警与精准识别' },
        closedLoop: { title: '多端联动闭环管理', desc: '打通"识别—告警—处置"全流程闭环管理，推动矿山安全治理数字化与智能化升级' }
      }
    },
    fa003: {
      name: '化工行业智能监管解决方案',
      banner: {
        title: '化工行业智能监管解决方案',
        desc: '以AI视频检测为核心，构建"人、物、环、管"四位一体的危化品作业安全防护网'
      },
      features: {
        wearDetect: { title: '危险区规范穿戴检测', desc: '实时识别作业人员是否穿戴防护服、防静电鞋，是否佩戴正压式空气呼吸器等特定防护装备。' },
        fireWarning: { title: '火灾烟雾毫秒预警', desc: '针对罐区、管廊等开阔空间，利用AI算法在明火生成初期即进行捕捉，比传统温烟感响应速度提升数倍。' },
        loadingDetect: { title: '装卸作业合规监管', desc: '针对危化品装卸区，自动识别鹤管位置、静电接地报警、装卸过程中的违规操作及人员脱岗现象。' },
        intrusionDetect: { title: '周界入侵与违规停留', desc: '对装置区、禁火区进行24小时电子围栏监测，自动识别翻越、违规使用手机、抽烟等极高风险行为。' }
      },
      advantages: {
        proactive: { title: '主动预警', desc: 'AI实时识别火灾烟雾、违规行为及安全隐患，实现风险主动发现、快速预警' },
        fullMonitor: { title: '全域监管', desc: '覆盖人员、设备、环境和作业流程，打造"人、物、环、管"一体化安全监管体系。' },
        linked: { title: '联动闭环', desc: '实现告警、处置、复核、追溯全流程闭环管理，全面提升化工企业本质安全水平' }
      }
    }
  },
  details: {
    WenMei: {
      banner: {
        title: 'AI设备专家平台',
        desc: '预测性维护系统，维修效率显著提升30%-50%'
      },
      list: {
        item1: { title: '设备管理', desc: '实现设备管理驾驶舱智能化' },
        item2: { title: '故障分析', desc: '将专家经验固化到流程中' },
        item3: { title: '数据报表', desc: '自动生成设备日报，应急报告等' }
      }
    },
    YiMei: {
      banner: {
        title: 'AI设备专家平台',
        desc: '预测性维护系统，维修效率显著提升30%-50%'
      },
      list: {}
    }
  }
}

export default zh